import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ccd0b190")

_pushScopeId("data-v-ccd0b190")
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "boxContainer" }
const _hoisted_3 = { class: "d-flex flex-wrap" }
const _hoisted_4 = { class: "square bg_grey" }
const _hoisted_5 = { class: "number" }
const _hoisted_6 = { class: "square bg_grey" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { class: "square bg_grey" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "square bg_grey" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { class: "square bg_grey" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = { class: "square bg_grey" }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "square bg_grey" }
const _hoisted_17 = { class: "number" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h3',
        localizedKey: "backoffice_Dashboard",
        text: "Dashboard",
        class: "text-uppercase fw_700 mb-0"
      }),
      _createVNode("button", {
        class: "primaryButton",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.init()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_Aggiorna",
          text: "Aggiorna"
        })
      ])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.model.registeredUser), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_PersoneCheHannoEffettuatoUnaRegistrazione/loginAllaWebApp",
            text: "Persone che hanno effettuato una registrazione/login alla web app",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.model.englishUsers), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_PersoneCheHannoEffettuatoUnaRegistrazione/loginInInglese",
            text: "Persone che hanno effettuato una registrazione/login in inglese",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.model.wristTaken), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_BraccialettiRitirati",
            text: "Braccialetti ritirati",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.model.welcomeKitTaken), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_WelcomeKitRitirati",
            text: "Welcome kit ritirati",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.model.photosTaken), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_NumeroDiFotoScattate",
            text: "Numero di foto scattate",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.model.photoDownload), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_NumeroDiFotoScaricate",
            text: "Numero di foto Scaricate",
            class: "white fs-18"
          })
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.model.photoShared), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_NumeroDiFotoCondivise",
            text: "Numero di foto Condivise",
            class: "white fs-18"
          })
        ])
      ])
    ])
  ], 64))
})